import { MobXModel } from "src/repository/MobXModel";
import { INewsClient } from "./INewsClient";

export const newsClientModel = new MobXModel<INewsClient>();
